import React, { useState, useEffect } from 'react';
import versionManager from '../utils/versionManager.js';
import '../styles/UpdatePrompt.css';

const VersionFooter = () => {
  console.log('[VersionFooter] TIMESTAMP:', Date.now()); // Cache buster
  const [versionInfo, setVersionInfo] = useState(null);

  useEffect(() => {
    try {
      const info = versionManager.getVersionInfo();
      console.log('[VersionFooter] Got version info:', info);
      setVersionInfo(info);
    } catch (error) {
      console.error('[VersionFooter] Error getting version info:', error);
    }
  }, []);

  if (!versionInfo) {
    console.log('[VersionFooter] No version info yet');
    return <span style={{color: '#8B7355', fontSize: '12px'}}>Loading...</span>;
  }

  const needsUpdate = versionInfo.needsUpdate;
  console.log('[VersionFooter] Rendering - needsUpdate:', needsUpdate);

  if (needsUpdate) {
    return (
      <button style={{
        background: 'rgba(184, 160, 130, 0.9)',
        color: '#2c3e50',
        border: 'none',
        borderRadius: '8px',
        padding: '3px 8px',
        fontSize: '11px',
        cursor: 'pointer',
        fontFamily: 'Courier New, monospace'
      }}>
        🔄 v{versionInfo.version} Update Available
      </button>
    );
  } else {
    return (
      <span style={{
        color: '#8B7355',
        fontSize: '12px',
        fontFamily: 'Courier New, monospace',
        padding: '2px 6px',
        borderRadius: '4px',
        background: 'rgba(184, 160, 130, 0.2)'
      }}>
        v{versionInfo.version}
      </span>
    );
  }
};

export default VersionFooter;